import React from 'react';

import { Title } from './styles';

export default ({ children, ...rest }) => {
  return (
    <Title {...rest}>
      {children}
    </Title>
  )
}
